import React from 'react';

const Sidebar = ({ isOpen, onClose, onNavigate }) => {
    return (
        <>
            {isOpen && (
                <div className="sidebar-overlay open" onClick={onClose}></div>
            )}

            <div className={`sidebar ${isOpen ? 'open' : ''}`}>
                <div className="sidebar-header">
                    <h3 className="sidebar-title">BBQ Menu</h3>
                    <button className="close-sidebar" onClick={onClose}>×</button>
                </div>

                <div className="sidebar-content">
                    <ul className="sidebar-menu">
                        <li>
                            <a href="#home" onClick={(e) => {
                                e.preventDefault();
                                onNavigate('home');
                            }}>Home</a>
                        </li>
                        <li>
                            <a href="#about" onClick={(e) => {
                                e.preventDefault();
                                onNavigate('about');
                            }}>About</a>
                        </li>
                        <li>
                            <a href="#gallery" onClick={(e) => {
                                e.preventDefault();
                                onNavigate('gallery');
                            }}>Gallery</a>
                        </li>
                    </ul>
                </div>
            </div>
        </>
    );
};

export default Sidebar; 